import request from '../../../../../setup/axios/request'
import requestFile from '../../../../../setup/axios/request-file'

const lang = localStorage.getItem('i18nConfig')
const lang_r = lang ? JSON.parse(lang).selectedLang : 'VI'

export const calculateFeeCar = (data: any) => {
  data.languageCode = lang_r.toUpperCase()
  return request({
    url: '/api/v1/Pricing/caculator-fee-car',
    method: 'post',
    data: data,
  })
}

export const step2GetContractPackageCar = (sellingContractId: string) => {
  let obj = {
    Includes: [],
    Filters: [
      {
        FieldName: 'SellingContractId',
        Comparision: '=',
        FieldValue: sellingContractId,
      },
    ],
    Page: '1',
    PageSize: '1000',
  }
  return request({
    url: '/api/v1/SellingCar/step2-contractPackage-car',
    method: 'get',
    headers: {
      'x-query': JSON.stringify(obj),
    },
  })
}

export const step2CreateCarContractPackage = (data: any) => {
  return request({
    url: '/api/v1/SellingCar/step2-create-contractPackage-car',
    method: 'post',
    data: data,
  })
}

export const step2DeleteCarContractPackageByid = (data: any) => {
  return request({
    url: '/api/v1/SellingCar/step2-delete-car-contractPackage-by-id',
    method: 'post',
    data: data,
  })
}

export const step2GetCarContractPackageByCode = (data: any) => {
  return request({
    url:
      '/api/v1/SellingCar/step2-car-contractPackage-by-code?code=' +
      data.code +
      '&sellingContractId=' +
      data.sellingContractId,
    method: 'get',
  })
}

export const step3GetObjectInsuredCarList = (data: any) => {
  let obj = {
    Page: data.pageNumber,
    PageSize: data.pageSize,
    Filters: data.filter,
  }

  return request({
    url: '/api/v1/SellingCar/step3-object-insured-car-list',
    method: 'get',
    headers: {
      'x-query': JSON.stringify(obj),
    },
  })
}

export const step3GetObjectInsuredCarByID = (data: any) => {
  return request({
    url:
      '/api/v1/SellingCar/step3-object-insured-car-detail-byid?sellingContractId=' +
      data.sellingContractId +
      '&id=' +
      data.id,
    method: 'get',
  })
}

export const step3ObjectInsuredCarDetailsAdd = (data: any) => {
  return request({
    url: '/api/v1/SellingCar/step3-object-insured-car-details-add',
    method: 'post',
    data: data,
  })
}

export const step3UploadCarInsured = (data: any) => {
  const formData = new FormData()
  formData.append('file', data.file)
  formData.append('SellingContractId', data.sellingContractId)
  formData.append('PackageCode', data.packagesCode)
  return requestFile({
    url: '/api/v1/SellingCar/step3-object-insured-car-details-insert-excel',
    method: 'post',
    data: formData,
  })
}

export const pricingCarPackageInfo = (code: string) => {
  return request({
    url: '/api/v1/Pricing/vehiclePackages?Code=' + code + '&languageCode=' + lang_r.toUpperCase(),
    method: 'get',
  })
}

export const getListPriceAuto = (data: any) => {
  return request({
    url:
      '/api/v1/Selling/vehicleInfo/get-all-priceDeclaration/' +
      data.vehicleInfosCode +
      '/' +
      data.code,
    method: 'get',
  })
}

export const addPriceDeclarationFromSelling = (data: any) => {
  return request({
    url: '/api/v1/Selling/add-price-declaration-from-selling',
    method: 'post',
    data: data,
  })
}